import React from 'react';
import classnames from 'classnames';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import detailsClasses from '../../../details/details.scss';
import CSSclasses from '../../quantity-block-multiple.scss';
const tooltipClasses = {
  tooltip: CSSclasses.tooltip,
  popper: CSSclasses.popper
};
export function QuantityBlockMultipleTitle({
  number,
  hasSelectedAssociatedProducts,
  isSharedItemEditing,
  isLimitedEdition,
  totalQuantity,
  preventFromEnterSubmission,
  onGeneralQuantityChange,
  label,
  minQuant,
  isCollectSizesAvailable,
  splitOrderMode,
  onStartCollectSizes,
  isCBSMode
}) {
  if (isCBSMode) {
    return /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.blockTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.blockTitleFirst
    }, /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.title
    }, "Calculate costs for your customers")));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.blockTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.blockTitleFirst
  }, /*#__PURE__*/React.createElement("h5", {
    className: CSSclasses.title
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.number
  }, number), "I would like", ' ', /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: "totalQuantity",
    label: "Quantity:"
  }), /*#__PURE__*/React.createElement("input", {
    id: "totalQuantity",
    "data-input": "TotalQuantity",
    className: classnames(CSSclasses.pink, {
      [CSSclasses.grayedOut]: !hasSelectedAssociatedProducts && isSharedItemEditing,
      [CSSclasses.orange]: isLimitedEdition
    }),
    value: totalQuantity,
    disabled: !hasSelectedAssociatedProducts && isSharedItemEditing,
    onKeyDown: preventFromEnterSubmission,
    onChange: e => onGeneralQuantityChange(e.target.value)
  }), ` ${label}`)), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.blockTitleSecond
  }, /*#__PURE__*/React.createElement("span", {
    className: detailsClasses.subHeader
  }, " (Min: ", minQuant, ")"), isCollectSizesAvailable && /*#__PURE__*/React.createElement(Tooltip, {
    title: `Please note that sizes can only be collected for one color.
                If you want to order multiple colors, you will need to manually adjust
                the quantity and sizes you plan to order for each color.`,
    mode: "light",
    placement: Placement.RIGHT,
    classes: tooltipClasses,
    disableHoverListener: !splitOrderMode
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.startCollectSizesButton,
    onClick: onStartCollectSizes,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onStartCollectSizes)
  }, "Need to collect sizes?"))));
}